import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedPhoneNumber from 'I18n/components/FormattedPhoneNumber';
import { ErrorMessage } from 'foundations-components/transitional/components/ErrorMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
/*
  A component used to signal that an error happened on our side. This includes
  client side runtime errors, 500s, or any other unexpected error states
*/
export default function FullPageError({
  companyName,
  supportEmail,
  supportPhone
}) {
  const message = companyName && supportEmail && supportPhone ? /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: "payments.errorState.genericErrorWithContactInfo_jsx",
    options: {
      href: window.location.href,
      companyName,
      email: supportEmail,
      phone: supportPhone
    },
    elements: {
      Link,
      Phone: FormattedPhoneNumber
    }
  }) : /*#__PURE__*/_jsx(FormattedJSXMessage, {
    message: "payments.errorState.genericError_jsx",
    options: {
      href: window.location.href
    },
    elements: {
      Link
    }
  });
  return /*#__PURE__*/_jsx(ErrorMessage, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "payments.errorState.errorTitle"
    }),
    children: /*#__PURE__*/_jsx("p", {
      children: message
    })
  });
}